/* open.icon.svg.js */

"use strict";
module.exports = {
    icon: `
        <svg viewBox="0 0 16 16" preserveAspectRatio="none">
            <path class="foreground-gl" d="M5.4,11.8V4c0-0.4,0.5-0.7,0.8-0.4l4.3,3.9c0.2,0.2,0.2,0.5,0,0.7l-4.2,4C5.9,12.5,5.4,12.3,5.4,11.8z"/>
        </svg>`,
    toggledIcon: `
        <svg viewBox="0 0 16 16" preserveAspectRatio="none">
            <path class="foreground-gl" d="M4.1,5.3h7.8c0.4,0,0.7,0.5,0.4,0.8l-3.9,4.3c-0.2,0.2-0.5,0.2-0.7,0L3.7,6.2C3.4,5.8,3.6,5.3,4.1,5.3z"/>
        </svg>`,
};
